export const CPG_REPORT_TAG = 'CpgReport';
export const TAGS = [CPG_REPORT_TAG];
